import React from 'react';
import { FaBolt, FaCircle } from 'react-icons/fa';

/**
 * Header moderno della pagina batch con indicatore di stato del sistema.
 * Lo "stato" è derivato dalla disponibilità delle risorse iniziali.
 */
export default function BatchHeader({ systemOnline, username }) {
  return (
    <header className="relative overflow-hidden rounded-2xl border border-gray-200 bg-gradient-to-br from-primary/10 via-white to-secondary/10 p-6 shadow-sm dark:border-gray-700 dark:from-primary/20 dark:via-gray-800 dark:to-gray-800">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-white shadow-md">
            <FaBolt size={22} />
          </span>
          <div>
            <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              Generatore Batch
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Generazione multipla SiSketron — anteprima del nuovo design
            </p>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <div
            className="flex items-center gap-2 rounded-full border border-gray-200 bg-white/70 px-3 py-1.5 text-xs font-medium backdrop-blur dark:border-gray-600 dark:bg-gray-900/50"
            aria-live="polite"
          >
            <FaCircle
              size={9}
              className={systemOnline ? 'text-emerald-500' : 'text-amber-500'}
            />
            <span className="text-gray-600 dark:text-gray-300">
              {systemOnline ? 'Sistema operativo' : 'Connessione in corso…'}
            </span>
          </div>
          {username && (
            <span className="hidden text-xs text-gray-500 dark:text-gray-400 sm:inline">
              {username}
            </span>
          )}
        </div>
      </div>
    </header>
  );
}
